module.exports = __webpack_public_path__ + "static/bus_urbano-3fafd9dc8c08ac2f93e59d16a1af8912.jpg";